import React from 'react';
import { Card, Col, Row, Image, Button, Tooltip } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

const CImagenArtEmpresa = ({ files, urls, setFiles, setUrls }) => {
  const getImageSrc = (index) => {
    if (files[index]) return URL.createObjectURL(files[index]);
    return urls[index] || null;
  };

  const handleRemove = (index) => {
    setFiles(prev => {
      const updated = [...prev];
      updated[index] = null;
      return updated;
    });
    setUrls(prev => {
      const updated = [...prev];
      updated[index] = '';
      return updated;
    });
  };

  const labels = ['Imagen Principal', 'Imagen 2', 'Imagen 3'];

  return (
    <Row gutter={16} style={{ marginTop: '1rem' }}>
      {labels.map((label, i) => {
        const src = getImageSrc(i);
        return (
          <Col span={8} key={i}>
            <Card
              title={label}
              bordered
              style={{ height: 300, position: 'relative' }}
              bodyStyle={{ paddingTop: src ? 0 : 80, textAlign: 'center' }}
            >
              {src ? (
                <>
                  <Tooltip title="Eliminar imagen">
                    <Button
                      shape="circle"
                      danger
                      icon={<DeleteOutlined />}
                      size="small"
                      onClick={() => handleRemove(i)}
                      style={{
                        position: 'absolute',
                        top: 12,
                        right: 12,
                        zIndex: 1,
                        boxShadow: '0 2px 6px rgba(0,0,0,0.15)'
                      }}
                    />
                  </Tooltip>
                  <Image
                    src={src}
                    alt={`Imagen ${i + 1}`}
                    width="100%"
                    height={220}
                    style={{ objectFit: 'cover', borderRadius: 4 }}
                    preview={false}
                  />
                </>
              ) : (
                <div style={{ color: '#aaa' }}>Sin imagen</div>
              )}
            </Card>
          </Col>
        );
      })}
    </Row>
  );
};

export default CImagenArtEmpresa;